import { axiosApi } from '@utils/fetch';

export const getAccountConnectToken = async (url: string, xApiKey: string): Promise<any> => {
    return await axiosApi({
        url: url,
        method: 'get',
        headers: {
            'x-api-key': xApiKey,
            siteId: '02'
        }
    }).then(res => res);
};

export const callDeleteOkta = async (baseUrl: string): Promise<any> => {
    return await axiosApi({
        url: `${baseUrl}/api/v1/sessions/me`,
        method: 'delete',
        withCredentials: true
    }).then(res => res);
};
